// `Symbol.toStringTag` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.tostringtag
require('../internals/define-well-known-symbol')('toStringTag');
